/**
 * How far through a countable thing something is, as a whole percentage.
 *
 * **ITS OWN MODULE because `<ProgressPie>` is a component.** A file exporting a component and
 * a function loses fast refresh for everything in it, which is why `buttonSurface.ts` and
 * `modalFooterSurface.ts` are their own files too.
 *
 * **ONE definition, because two surfaces state this figure.** A fulfilment register draws the
 * wedge on its list rows and the same percentage as a column in its table — written twice, the
 * two would eventually round differently and a reader switching view would meet `99%` beside
 * `100%` for one record, with both screens internally consistent.
 */
export function progressPercent(value: number, total: number): number {
  if (total <= 0) return 0;

  const done = Math.min(Math.max(value, 0), total);

  /*
    FLOORED, and 100 ONLY WHERE IT IS ACTUALLY COMPLETE. Rounding is what puts `100%` on a
    record with a line still outstanding — 59 of 60 rounds to 100 and reads as finished, which
    is the one thing a fulfilment figure must never say wrongly. The exact case is stated
    rather than left to the arithmetic, because flooring alone would report 99%.

    The floor cuts the other way too and is accepted: one line of a 300-line request reads 0%.
    A register of requests does not reach those lengths, and the wedge is drawn from the raw
    fraction regardless — the caption is the approximation, never the shape.
  */
  return done === total ? 100 : Math.floor((done / total) * 100);
}
